<template>
  <section>
    <div id="order_view_model" class="modal fade" role="dialog" ref="viewOrderModal" data-keyboard="false"
         aria-labelledby="myModalLabel">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <!--<button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>-->
            <h4 class="modal-title">
              <b class="pull-left">Order #: {{ order.id }}</b>
              <b class="pull-right">Current Status:
                {{ order.statusesByStatusId ? order.statusesByStatusId.name : 'N/A' }}</b>
            </h4>
            <br/>
          </div>
          <div class="modal-body">
            <div class="row" v-if="showActions === 'true'">
              <div class="col-md-12">
                <div class="btn-group open pull-right">
                  <div data-toggle="dropdown" id="dropdown-toggle"
                       v-bind:class="'btn btn-primary btn-xs ld-ext-right ' + actionBtnLoadingClass"
                       aria-expanded="true">
                    Actions
                    <span class="caret"></span>
                    <div class="ld ld-ring ld-spin"></div>
                  </div>
                  <ul class="dropdown-menu">
                    <li v-if="order.statusesByStatusId && order.statusesByStatusId.id === 7 && userRole !== 'ROLE_BRANCH'">
                      <a href="javascript:void(0)" v-on:click="pushOrderToBranch()">Re - Push Order To Vendor</a></li>
                    <li><a href="javascript:void(0)" v-on:click="showComplaintForm()">Register Complain</a></li>
                    <li v-if="userRole !== 'ROLE_BRANCH' && canUpdateOrderStatus()"><a href="javascript:void(0)"
                                                                                       v-on:click="showChangeOrderStatusForm()">Change
                      Order Status</a></li>
                    <li v-if="order.statusesByStatusId && order.statusesByStatusId.id === 10"><a
                        href="javascript:void(0)" v-on:click="assignRider()">Assign Rider</a></li>
                    <li v-if="order.statusesByStatusId && order.statusesByStatusId.id === 27 && !order.isAcknowledgedScheduleOrder">
                      <a href="javascript:void(0)" @click="acknowledgedScheduleOrder()">Acknowledge Order</a></li>
                    <li v-if="(userRole === 'ROLE_ADMIN' || userRole === 'ROLE_AGENT') && order.dvmAddress !== null"><a
                        href="javascript:void(0)" @click="editOrder()">Update Order</a></li>
                  </ul>
                </div>
                <button type="button" class="btn btn-warning pull-right btn-xs ld-ext-right mr-1 m-r"
                        @click="printOrder">Print
                </button>
              </div>
            </div>

            <div v-if="order.table!==null">
              <legend>POS Details</legend>
              Order Type: <b>{{ order.orderTypesByOrderTypeId.type }}</b><br/>
              Assigned Slot: <b>{{ order.table.name }}</b><br>
              <span v-if="order.waiter!=null">Assigned Waiter: <b>{{ order.waiter.name }}</b></span><br><br>
            </div>
            <CustomerDetails v-else ref="customerDetails" v-bind:order="order"
                             :bebambiCustomerAddresses="bebambiCustomerAddresses"></CustomerDetails>
            <legend v-if="order.table===null && order.orderTypesByOrderTypeId.id!==1">Order Items -
              ({{ order.id === 0 ? 'Distance to cover by Rider' : 'Distance Covered By Rider' }}:
              <span class="badge badge-info">{{ order.totalDistance }}</span> Km)
              <button type="button" class="btn btn-primary btn-xs ld-ext-right pull-right" v-if="isEditOrder"
                      @click="addItem()">Add Item
              </button>
            </legend>
            <legend v-else>
              Order Items
              <button type="button" class="btn btn-primary btn-xs ld-ext-right pull-right" v-if="isEditOrder"
                      @click="addItem()">Add Item
              </button>
            </legend>

            <table class="table table-bordered table-hover table-striped">
              <thead>
              <tr>
                <th class="text-center">Name</th>
                <th class="text-center">Serving</th>
                <th class="text-center">Price</th>
                <th class="text-center">Quantity</th>
                <th class="text-center">Total Price</th>
                <th class="text-center">Discounted Price</th>
                <th class="text-center">Special Instruction</th>
                <th class="text-center" v-if="isEditOrder">Actions</th>
              </tr>
              </thead>
              <tbody>
              <template v-for="(orderItem, orderItemIndex) in order.orderItemsById">
                <tr :key="orderItemIndex + '_' + orderItem.id">

                  <td class="text-center">
                    <span v-if="currentlyEditingIndex !== orderItemIndex || !editItemButton">{{
                        orderItem.menuItemTypesByMenuItemTypeId.menuItemsByMenuItemId.name
                      }}</span>
                    <select v-else class="styleSelectElement menu_item_select_box"
                            :id="'orderItem_' + orderItem.id"
                            @change="handleItemChange(orderItem.menuItemTypesByMenuItemTypeId.menuItemsByMenuItemId.name, $event.target.value, orderItem.id)">
                      <option disabled selected
                              :value="orderItem.menuItemTypesByMenuItemTypeId.menuItemsByMenuItemId.id">
                        {{ orderItem.menuItemTypesByMenuItemTypeId.id }} -
                        {{ orderItem.menuItemTypesByMenuItemTypeId.menuItemsByMenuItemId.name }}
                      </option>
                      <option
                          v-for="menuItem in menuItems.filter(e => e.id !== orderItem.menuItemTypesByMenuItemTypeId.menuItemsByMenuItemId.id)"
                          :value="menuItem.id">
                        {{ menuItem.name }}
                      </option>
                    </select>
                  </td>

                  <td class="text-center">{{ orderItem.menuItemTypesByMenuItemTypeId.serving }}</td>
                  <td class="text-center">{{ orderItem.menuItemTypesByMenuItemTypeId.price }}</td>

                  <td class="text-center">
                    <span v-if="currentlyEditingIndex !== orderItemIndex || !editItemButton">{{
                        orderItem.quantity
                      }}</span>
                    <input v-else :value="orderItem.quantity"
                           @change="handleQuantityChange(orderItem.menuItemTypesByMenuItemTypeId.id, orderItem.id, $event.target.value, orderItem.quantity)"
                           type="number"
                           placeholder="Quantity"
                           style="height: 3rem; width: 60%;"/>
                  </td>

                  <td class="text-center">{{ orderItem.totalPrice }}</td>
                  <td class="text-center">{{ orderItem.discountedPrice }}
                    <i style="color: #e30b72;">({{ getItemWideDiscount(orderItem) | formatNumber }}%)</i>
                  </td>
                  <td class="text-center text-danger">{{ orderItem.instructions ? orderItem.instructions : 'N/A' }}</td>

                  <td class="text-center" v-if="isEditOrder">
                    <div class="btn-group">
                      <a @click="editButton(orderItemIndex, orderItem.menuItemTypesByMenuItemTypeId.menuItemsByMenuItemId.name, orderItem.quantity)">
                        <i title='Edit' class='fa fa-pencil'></i>
                      </a>
                      <span class="vertical-divider"></span>
                      <a @click="deleteOrderItem(orderItem.menuItemTypesByMenuItemTypeId.id, orderItem.id)">
                        <i title='Delete' class='fa fa-trash'></i>
                      </a>
                    </div>
                  </td>
                </tr>
                <template v-for="(itemAddOn, index) in orderItem.orderItemAddOnsById">
                  <tr v-bind:key="index+'_'+orderItemIndex+'_'+itemAddOn.addOnItemsByAddOnItemId.name">
                    <td colspan="3" class="text-right"><b>Add On</b></td>
                    <td class="text-center">{{ itemAddOn.addOnItemsByAddOnItemId.name }}</td>
                    <td class="text-center">
                      {{ itemAddOn.addOnItemsByAddOnItemId.addOnCategoriesByAddOnCategoryId.name }}
                    </td>
                    <td class="text-center">
                      {{ (itemAddOn.quantity * itemAddOn.addOnItemsByAddOnItemId.price) + ' => (' + itemAddOn.addOnItemsByAddOnItemId.price + ' X ' + itemAddOn.quantity + ')' }}
                    </td>
                  </tr>
                </template>
              </template>
              <tr>
                <td colspan="6" class="text-right">Sub Total</td>
                <td :colspan="isEditOrder ? 7 : 6" class="text-right">{{ order.totalPrice | formatNumber }} Rs.</td>
              </tr>
              <tr>
                <td colspan="6" class="text-right">Sub Total With AdOn'S</td>
                <td :colspan="isEditOrder ? 7 : 6" class="text-right">{{ order.totalPriceWithAddon | formatNumber }}
                  Rs.
                </td>
              </tr>

              <tr>
                <td colspan="6" class="text-right">
                  <template v-if="order.orderSource.id === 7">
                    Tax Amount:
                  </template>
                  <template v-else>
                    Tax Amount
                    <b v-if="order.paymentMethod !== null && order.paymentMethod === 'cash'" class="text-info">
                      ({{ order.branchesByBranchId.tax }}%)
                    </b>
                    <b v-if="order.paymentMethod !== null && order.paymentMethod === 'card'" class="text-info">
                      ({{ order.branchesByBranchId.cardTax }}%)
                    </b>
                  </template>
                </td>
                <td :colspan="isEditOrder ? 7 : 6" class="text-right">
                  <template v-if="order.orderSource.id === 7">
                    {{ Math.round(0) }} Rs.
                  </template>
                  <template v-else>
                    {{
                      Math.round((this.order.totalPriceAfterTax + this.order.discount) - this.order.totalPriceWithAddon)
                    }} Rs.
                  </template>
                </td>
              </tr>


              <tr>
                <td colspan="6" class="text-right">Sub Total After Tax</td>
                <td :colspan="isEditOrder ? 7 : 6" class="text-right">
                  <template v-if="order.orderSource.id === 7">
                    {{ order.totalPriceWithAddon | formatNumber }} Rs.
                  </template>
                  <template v-else>
                    {{ order.totalPriceAfterTax | formatNumber }} Rs.
                  </template>
                </td>
              </tr>


              <tr v-if="!order.branchesByBranchId.freeDelivery ">
                <td colspan="6" class="text-right">Delivery Fee</td>
                <td :colspan="isEditOrder ? 7 : 6" class="text-right">{{ order.deliveryFee | formatNumber }} Rs.</td>
              </tr>
              <tr v-if="order.branchesByBranchId.freeDelivery ">
                <td colspan="6" class="text-right">Delivery Fee</td>
                <td><b class="label label-danger">Not Charged To Customer</b></td>
                <td :colspan="isEditOrder ? 7 : 6" class="text-right">{{ order.deliveryFee | formatNumber }} Rs.</td>
              </tr>
              <tr v-if="totalItemWideDiscount !== 0">
                <td colspan="6" class="text-right">Item Wide Discount</td>
                <td :colspan="isEditOrder ? 7 : 6" class="text-right">{{ totalItemWideDiscount | formatNumber }} Rs.
                </td>
              </tr>
              <tr>
                <td :colspan="couponApplied ? 5 : 6" class="text-right">Discount</td>
                <td :colspan="isEditOrder ? 7 : 6" class="center" v-if="couponApplied">
                  <span class="label label-info">({{ order.couponsByCouponId.couponCode }}) - ({{
                      (order.couponsByCouponId.inPercentage) ? order.couponsByCouponId.discount + "%" : order.couponsByCouponId.discount + ".RS"
                    }})</span>
                </td>
                <td :colspan="isEditOrder ? 7 : 6" class="text-right">
                  {{ (order.discount - totalItemWideDiscount) | formatNumber }} Rs.
                </td>
              </tr>
              <tr v-if="totalItemWideDiscount !== 0">
                <td colspan="6" class="text-right">Total Discount</td>
                <td :colspan="isEditOrder ? 7 : 6" class="text-right">{{ order.discount | formatNumber }} Rs.</td>
              </tr>
              <tr>
                <td colspan="6" class="text-right">Billed Price</td>
                <td :colspan="isEditOrder ? 7 : 6" class="text-right">{{ order.billedPrice | formatNumber }} Rs.</td>
              </tr>
              <tr v-if="order.paymentMethod!==null">
                <td colspan="6" class="text-right">Payment Method</td>
                <td :colspan="isEditOrder ? 7 : 6" class="text-right">
                  {{ (order.paymentMethod !== null) ? order.paymentMethod.name : "N/A" }}
                </td>
              </tr>
              <tr>
                <td colspan="6" class="text-right">Payment Status</td>
                <td :colspan="isEditOrder ? 7 : 6" class="text-right">
                  {{ (order.paymentStatus !== null) ? order.paymentStatus.name : "N/A" }}
                </td>
              </tr>
              <tr v-if="order.table!==null">
                <td colspan="6" class="text-right">Cash Taken</td>
                <td :colspan="isEditOrder ? 7 : 6" class="text-right">{{ order.cashTaken | formatNumber }} Rs.</td>
              </tr>
              <tr v-if="order.table!==null">
                <td colspan="6" class="text-right">Cash Given</td>
                <td :colspan="isEditOrder ? 7 : 6" class="text-right">{{ order.cashGiven | formatNumber }} Rs.</td>
              </tr>
              </tbody>
            </table>
            <!--<span th:if="*{rider != null}">-->
            <!--<legend>Rider Details</legend>-->
            <!--<span>Name: <b th:text="*{rider.name}"></b></span><br/>-->
            <!--<span>Contact <b th:text="*{rider.contact1}"></b></span><br/>-->
            <!--<span>CNIC: <b th:text="*{rider.cnic}"></b></span><br/>-->
            <!--<span>Vehicle Number: <b th:text="*{rider.vehicleNumber}"></b></span>-->
            <!--</span>-->

            <legend>Order Wide Instructions</legend>
            <span class="text-danger">
                          <b>{{ (order.orderWideInstructions != null) ? order.orderWideInstructions : "No Order Wide Instructions" }}</b>
                        </span>
            <br/><br/>
            <div v-if="order.dvmAddress !== null">
              <div class="row custom_styling_on_row">
                <legend :class="(order.ordersRating !== null) ? 'col-md-4 order_feedback' : ''">
                  Bebambi Order Feedback
                </legend>
                <legend v-if="order.ordersRating !== null" class="col-md-8 order_feedback">
                  <StarRating class="pull-right"
                              :rating="order.ordersRating.rating"
                              :read-only="true"
                              :star-size="20"
                              :show-rating="false"
                              :increment="0.01"
                              :title="OrderRatingTitle">
                  </StarRating>
                </legend>
              </div>
              <span class="text-justify">
                              {{ (order.ordersRating !== null && order.ordersRating.feedbackText !== null) ? order.ordersRating.feedbackText : "No Feedback Available" }}
                          </span>
              <br/><br/>
            </div>
            <div class="row">
              <div v-bind:class="(order.ridersByRiderId === null)? 'full_legend' : 'col-md-8 pull-left half_legend'">
                <legend>Warehouse</legend>
                <span>Name: <b>{{ order.branchesByBranchId.restaurantsByRestaurantId.name }}</b></span><br/>
                <span>Vendor: <b>{{ order.branchesByBranchId.areasByAreaId.name }}</b></span><br/>

                <span>Phone 1: <b>{{ (order.branchesByBranchId.phone1 !== "") ? order.branchesByBranchId.phone1 : "N/A" }}</b></span><br/>
                <span>Contact Name 1:
                              <b>
                                {{ (order.branchesByBranchId.contactName1 !== "" && order.branchesByBranchId.contactName1 !== null) ? order.branchesByBranchId.contactName1 : "N/A" }}
                              </b>
                            </span>
                <br/>

                <span>Phone 2: <b>{{ (order.branchesByBranchId.phone2 !== "") ? order.branchesByBranchId.phone2 : "N/A" }}</b></span><br/>
                <span>
                              Contact Name 2:
                              <b>
                                {{ (order.branchesByBranchId.contactName2 !== "" && order.branchesByBranchId.contactName2 !== null) ? order.branchesByBranchId.contactName2 : "N/A" }}
                              </b>
                            </span>
                <br/>

                <span>Phone 3: <b>{{ (order.branchesByBranchId.phone3 !== "") ? order.branchesByBranchId.phone3 : "N/A" }}</b></span><br/>
                <span>
                              Contact Name 3:
                              <b>
                                {{ (order.branchesByBranchId.contactName3 !== "" && order.branchesByBranchId.contactName3 !== null) ? order.branchesByBranchId.contactName3 : "N/A" }}
                              </b>
                            </span>
                <br/>
              </div>
              <div class="branch col-md-4 pull-right" v-if="order.ridersByRiderId">
                <legend>Assigned Rider</legend>
                <span>Name: <b>{{ order.ridersByRiderId.name }}</b></span><br>
                <span>Contact Number: <b>{{ order.ridersByRiderId.contact }}</b></span><br>
                <span>Vehicle Number: <b>{{ order.ridersByRiderId.vehicleNumber }}</b></span>
              </div>
            </div>
            <br/><br/>
            <div v-if="order.usersByUserId!==null">
              <legend>Order Taken By:</legend>
              <span>Name: <b>{{ order.usersByUserId.fullName }}</b></span><br/>
              <span>Contact <b>{{ order.usersByUserId.contact }}</b></span><br/>
              <span>Email: <b>{{ order.usersByUserId.email }}</b></span><br/>
              <br/><br/>
            </div>
            <div v-if="order.table===null && order.orderTypesByOrderTypeId.id!==1">
              <legend>Estimated Delivery Time:
                {{ order.expectedDeliveryMinutes ? order.expectedDeliveryMinutes + ' Min' : "N/A" }}
              </legend>

              <br/><br/>
            </div>
            <legend>Order Status History  {{ order.orderHistoriesById.length > 0 ? '' : ": N/A" }}</legend>
            <span v-if="order.scheduleNow !== null" class="text-danger">
                            <b>Scheduled At: ({{ $moment.parseZone(String(order.scheduleNow)).local().format('DD/MM/YYYY hh:mm:ss A') }})</b>
                        </span>
            <table class="table table-bordered table-hover table-condensed">
              <thead>
              <tr>
                <th class="text-center">Status</th>
                <th class="text-center">Created</th>
                <th class="text-center">User</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(history, hIndex) in order.orderHistoriesById"
                  v-bind:key="'historyKey'+history.created +'_'+ hIndex">
                <td class="text-center">
                  <span
                      v-bind:class="'label ' + history.statusesByStatusId.cssClass">{{ history.statusesByStatusId.name }}</span>
                </td>
                <td class="text-center">
                  <span
                      v-bind:class="'label ' + history.statusesByStatusId.cssClass">{{ history.statusesByStatusId.name === 'CREATED' ? $moment.parseZone(String(history.posCreated)).local().format('DD/MM/YYYY hh:mm:ss A') : $moment.parseZone(String(history.created)).local().format('DD/MM/YYYY hh:mm:ss A') }}</span>
                </td>
                <td class="text-center">
                                      <span v-bind:class="'label ' + history.statusesByStatusId.cssClass">
                                        {{ history.usersByUserId !== null ? history.usersByUserId.fullName : "Auto Assigned" }}
                                      </span>
                </td>
              </tr>
              </tbody>
            </table>

            <legend>Order Tracking History</legend>
            <table class="table table-bordered table-hover table-condensed">
              <tbody>
              <!-- Loop through userActivityLogs to display history -->
              <tr v-for="(history, hIndex) in userActivityLogs"
                  v-bind:key="'historyKey' + history.created + '_' + hIndex">
                <td class="text-left">
                  <div>
                    <!-- Display history: User updated field with date and time -->
                    <p style="font-size: 14px;">
                      <b>{{ toCamelCase(history.username) }}</b> updated the
                      <b>{{ history.field }}</b>
                      on {{ $moment.parseZone(String(history.created)).local().format('MMMM DD, YYYY [at] hh:mm A') }}
                    </p>

                    <!-- Display old value -> new value with styled <span> and icon -->
                    <h4>
                      <!-- Styling for old and new value spans with margin and black text color -->
                      <span class="label label-success" style="color: black; margin-right: 5px;">{{ history.oldValue }}</span>
                      <icon class="fa fa-angle-double-right" aria-hidden="true" style="margin: 0 5px;"></icon>
                      <span class="label label-success" style="color: black; margin-left: 5px;">{{ history.newValue }}</span>
                    </h4>
                  </div>
                </td>
              </tr>

              <!-- Dummy row if no history available -->
              <tr v-if="userActivityLogs.length === 0">
                <td class="text-left">No history available.</td>
              </tr>
              </tbody>
            </table>




            <section v-if="order.statusesByStatusId && order.statusesByStatusId.id === 9">
              <br/><br/>
              <legend>Cancel Reasons</legend>
              <label><b class="text-danger">{{
                  (order.orderCancellationReasonsId.id === 4) ? order.otherCancelReasons :
                      order.orderCancellationReasonsId.reason
                }}</b></label>
              <br>
              <label><b
                  class="text-danger">{{ (order.orderCancellationReasonsId.id === 4) ? "" : " " + order.otherCancelReasons }}</b></label>
            </section>

            <section v-if="showActions === 'true' && order.complaints.length > 0">
              <br/><br/>
              <legend>Order Complaints</legend>
              <div class="list-group">
                <a class="list-group-item" v-for="(complaint, cIndex) in order.complaints"
                   v-bind:key="'viewOrderComplaint_'+complaint.id + '_' + cIndex">
                  <h3 class="list-group-item-heading">
                    Created On: <small>{{ complaint.created }}</small>
                    <span class="pull-right">{{ complaint.status + ' => (' + complaint.id + ')' }}</span>
                  </h3>
                  <p class="list-group-item-text">{{ complaint.complaint }}</p>
                  <ul class="list-inline" v-if="userRole === 'ROLE_AGENT' && complaint.requestOfAction === 0">
                    <li><a v-on:click="doActionOnComplaint(1, cIndex)">Request To Resolve</a></li>
                    <li><a v-on:click="doActionOnComplaint(2, cIndex)">Request To Ignore</a></li>
                  </ul>
                  <ul class="list-inline" v-if="complaint.requestOfAction !== 0">
                    <li>Mr. {{ complaint.actionRequestedBy }} has requested to
                      <b>{{ (complaint.requestOfAction === 1) ? 'Resolve' : 'Ignore' }}</b> this complaint
                    </li>
                  </ul>
                </a>
              </div>
            </section>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary" data-dismiss="modal" v-if="punchOrderButton"
                    v-on:click="$parent.saveOrder()">Punch Order
            </button>
            <button type="button" class="btn btn-info" @click="updateOrder" v-if="isEditOrder">Save</button>
            <button type="button" class="btn btn-default" @click="close" data-dismiss="modal">Close</button>
          </div>
        </div><!-- /.modal-content -->
      </div><!-- /.modal-dialog -->
    </div><!-- /.modal -->
    <OrderComplaint v-bind:orderId="order.id"/>
    <ChangeOrderStatus :statuses="orderStatuses"
                       v-bind:orderId="order.id"
                       :current-status-id="(order.statusesByStatusId !== null) ? order.statusesByStatusId.id : 0"
                       :order-type-id="order.orderTypesByOrderTypeId.id"
                       :restaurantId="this.order.branchesByBranchId.restaurantsByRestaurantId.id"
    />
    <AssignRider ref="assignRiderModal"/>
    <PrintOrder :order="order" id="print-order" style="display:none"/>
  </section>
</template>

<script>
/* eslint-disable */
import OrderComplaint from "@/components/complaints/OrderComplaint";
import ChangeOrderStatus from "./ChangeOrderStatus";
import AssignRider from "@/components/riders/AssignRider"
import CustomerDetails from "./CustomerDetails"
import StarRating from 'vue-star-rating';
import {getAllCustomerAddresses, getBaykedCustomerAddresses} from "@/api/customers";
import {updateOrder} from "@/api/orders";
import {deleteCoupon, getMenuItemByBranchId} from "@/api/restaurants";
import {UpdateOrderFields} from "@/Utils/Constants/UpdateOrderFields";
import PrintOrder from "@/components/orders/PrintOrder.vue";
import {updateCustomDeliveryFee} from "@/api/orders";

export default {
  name: "ViewOrder",
  components: {
    PrintOrder,
    ChangeOrderStatus,
    OrderComplaint,
    AssignRider,
    CustomerDetails,
    StarRating,
  },
  props: {
    showActions: String,
    orderStatuses: Array,
  },
  data: function () {
    return {
      userRole: "",
      actionBtnLoadingClass: "",
      updatedAddress: '',
      OrderRatingTitle: "",
      editOrderObject: [],
      currentlyEditingIndex: null,
      isNewItem: false,
      order: {
        "id": 0,
        "totalPrice": 9654,
        "discount": 25,
        "billedPrice": 783,
        "created": "2018-11-03T19:00:00.000+0000",
        "modified": "2018-11-03T19:00:00.000+0000",
        "deliveryFee": 100,
        "cancelReasons": null,
        "commission": null,
        "totalDistance": 5,
        "totalPriceAfterTax": 783,
        "totalPriceWithAddon": 650,
        "pushTries": 1,
        "complaints": [],
        "table": null,
        "waiter": {
          "name": ""
        },
        "orderHistoriesById": [
          {
            "created": "2018-11-03T19:00:00.000+0000",
            "statusesByStatusId": {
              "id": 10,
              "name": "READY FOR DELIVERY",
              "cssClass": "label-info"
            },
            "usersByUserId": {
              "branch": null,
              "contact": "",
              "email": "",
              "fullName": "",
              "id": 0,
              "restaurant": null,
              "username": "",
            }
          }
        ],
        "orderItemsById": [
          {
            "id": 1,
            "quantity": 1,
            "totalPrice": 650,
            "discountedPrice": 0,
            "instructions": "These are ins",
            "orderItemAddOnsById": [
              {
                "id": 1,
                "quantity": 2,
                "addOnItemsByAddOnItemId": {
                  "id": 1,
                  "name": "Pepsi",
                  "price": 55,
                  "addOnCategoriesByAddOnCategoryId": {
                    "name": "Fries & Drinks",
                    "allowedItems": 1
                  }
                }
              }
            ],
            "menuItemTypesByMenuItemTypeId": {
              "price": 199,
              "serving": "1 Bucket",
              "menuItemsByMenuItemId": {
                "id": 145,
                "name": "Hot Cowgirl",
                "description": "Masala Fries\n",
                "menuCategoriesByMenuCategoryId": {
                  "name": "FRIES"
                }
              }
            }
          }
        ],
        "orderSource": {
          "id": 0,
          "source": ""
        },
        "branchesByBranchId": {
          "freeDelivery": true,
          "tax": 16,
          "restaurantsByRestaurantId": {
            "name": "Howdy"
          },
          "areasByAreaId": {
            "name": "Johar Town Block R3",
            "citiesByCityId": {
              "city": "Lahore"
            }
          }
        },
        "statusesByStatusId": {
          "id": 0,
          "name": "",
          "cssClass": "label-success"
        },
        "customerAddressesByCustomerAddressId": {
          "address": "House # 261, B - Block, Valencia Town.",
          "customersByCustomerId": {
            "name": "Salman Youasf",
            "contact1": "03214948660",
            "contact2": null,
            "contact3": null,
            "email": "salman.yousaf47@gmail.com"
          },
          "areasByAreaId": {
            "name": "Valencia Town Block B1",
            "citiesByCityId": {
              "city": "Lahore"
            }
          }
        },
        "couponsByCouponId": null,
        "usersByUserId": {
          "id": 50,
          "username": "splashing75",
          "fullName": "New Salman Yousaf",
          "contact": "032196385245",
          "email": "salman.yousaf@septemsystems.com"
        },
        "orderTypesByOrderTypeId": {
          "type": "Delivery"
        },
        "ordersRating": null,
        "paymentMethod": {
          "id": '',
          "name": ''
        },
        "paymentStatus": {
          "id": '',
          "name": ''
        }
      },
      userActivityLogs: [],
      punchOrderButton: false,
      isEditOrder: false,
      editItemButton: false,
      totalItemWideDiscount: 0,
      bebambiCustomerAddresses: [],
      menuItems: [],
      quantity: 0,
      menuItemsLoaded: false,
      item: "0"
    }
  },
  computed: {
    couponApplied() {
      return this.order.couponsByCouponId !== null;
    }
  },
  watch: {
    updatedAddress: {
      handler(newAddress) {
        this.addAddressToEditOrderArray(newAddress)
      }
    }
  },
  created: function () {
    let loggedInUser = this.$store.state.user;
    if (loggedInUser) {
      this.userRole = loggedInUser.userRolesById[0].role;
    }
  },
  mounted: function () {
    if (this.$parent.dtTable !== undefined) {
      $("#order_view_model").on('hidden.bs.modal', (e) => {
        this.$parent.dtTable.draw();
        this.close()
      });
    }
    $("#star-rating").tooltip({placement: "right"});
    $('#dropdown-toggle').dropdown('toggle');
    $(".updateAreaBtn").click(function () {
      this.editButton();
    });
  },
  methods: {
    toCamelCase(username) {
      if (!username) return '';
      // Remove special characters and symbols, keeping only alphabetic characters and spaces
      return username
          .replace(/[^a-zA-Z\s]/g, '') // Remove any character that is not a letter or space
          .toLowerCase() // Convert to lowercase
          .split(' ') // Split into words
          .map(word => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize each word
          .join(' '); // Join words back into a string
    },
    fetchOrderDetail: function (orderId) {
      let params = new URLSearchParams();
      params.append('order_id', orderId);
      this.$http.post(this.$store.state.mainAppURL + "orders/get_order_detail", params).then((response) => {
        this.order = response.data;
        if (this.order.ordersRating !== null && this.order.ordersRating.rating !== null) {
          this.OrderRatingTitle = "Order Rating: " + this.order.ordersRating.rating;
        }
        this.totalItemWideDiscount = this.calculateTotalOrderItemWideDiscount();
        $("#order_view_model").modal("show");
      }).catch(function (error) {
        console.log(error);
      });
    },
    fetchUserActivityLogs: function (orderId) {
      console.log("Fetching user activity logs");

      // Correct GET request format with params
      this.$http.get(this.$store.state.mainAppURL + "orders/get_user_activity_logs/" + orderId, {})
          .then((response) => {
            // Log the response to see what data is being returned
            console.log("Activity logs response: ", response.data);

            // Ensure that the data is properly received and assigned
            if (response.data.body && response.data.body.length) {
              this.userActivityLogs = response.data.body;  // Store the logs if present
            } else {
              console.log("No activity logs found");
              this.userActivityLogs = [];  // Handle empty logs scenario
            }
          })
          .catch(function (error) {
            console.error("Error fetching activity logs:", error);
          });
    },

    getItemWideDiscount: function (orderItem) {
      return 100 - ((orderItem.totalPrice - orderItem.discountedPrice) / orderItem.totalPrice) * 100
    },
    calculateTotalOrderItemWideDiscount: function () {
      let totalDiscount = 0
      for (const orderItem of this.order.orderItemsById) {
        totalDiscount += orderItem.discountedPrice
      }
      return totalDiscount;
    },
    showComplaintForm: function () {
      $("#complaint_modal").modal("show");
    },
    showChangeOrderStatusForm: function () {
      $("#changeOrderStatusModal").modal("show");
    },
    pushOrderToBranch: function () {
      let params = new URLSearchParams();
      params.append('order_id', this.order.id);
      this.actionBtnLoadingClass = "running";
      this.$http.post(this.$store.state.mainAppURL + "orders/push_order_to_branch", params).then(resp => {
        if (resp.data) {
          swal("SUCCESS!", "Order has been successfully pushed", "success");
        } else {
          swal("ERROR!", "There is some error in pushing order to branch! Please try again.", "error");
        }
        this.actionBtnLoadingClass = "";
      });
    },
    doActionOnComplaint: function (action, cIndex) {
      let complaint = this.order.complaints[cIndex];
      swal({
        title: "Complaint Solution / Notes",
        text: "Please Enter Complaint Solution / Notes.",
        type: "info",
        input: 'textarea',
        inputPlaceholder: "Notes...",
        showCancelButton: true,
        allowOutsideClick: false,
        allowEscapeKey: false,
        confirmButtonText: "REQUEST!",
        showLoaderOnConfirm: true,
        preConfirm: (notes) => {
          return notes;
        },
      }).then((result) => {
        console.log(result);
        if (result.value) {
          complaint["orders"] = {};
          complaint["orders"].id = complaint["orderId"];
          complaint.requestOfAction = action;
          complaint.actionRequestedBy = this.$store.state.user["fullName"];
          complaint.actionRequestedOn = new Date();
          complaint.complaintSolution = result.value;
          this.$http.post(this.$store.state.mainAppURL + "complaints/register_generic_complaint", complaint).then((response) => {
            if (response.data) {
              swal("SUCCESS!", "Your request has been sent to admin", "success");
            } else {
              swal("ERROR!", "Error! Contact Musab Bukahri", "error");
            }
          }).catch(function (error) {
            console.log(error);
          });
        }
      });

    },
    async updateDeliveryFee(contact, customDeliveryCharges) {
      try {
        let params = new FormData();
        params.append("caller_number", contact);
        params.append("custom_delivery_charges", customDeliveryCharges);
        await updateCustomDeliveryFee(params)
      } catch (e) {
        console.log(e)
      }
    },
    async fetchOrderToPunchDetail(contact, customDeliveryCharges) {

      await this.updateDeliveryFee(contact, customDeliveryCharges)
      this.punchOrderButton = true;
      let params = new URLSearchParams();
      params.append("contact_number", contact);
      this.$http.post(this.$store.state.mainAppURL + "orders/check_delivery_order_request", params).then(resp => {
        if (resp.data === null || resp.data === "") {
          swal("Error!", "No Order data to show!", "error");
          return;
        } else {
          this.order = resp.data
        }
        $("#order_view_model").modal("show");
      }).catch(function (error) {
        console.log(error);
      });
    },
    acknowledgedScheduleOrder() {
      let params = new URLSearchParams();
      params.append("order_id", this.order.id);
      this.$http.post(this.$store.state.mainAppURL + "orders/acknowledge_schedule_order", params).then(resp => {
        if (resp.data === null || resp.data === "") {
          swal("Error!", "Unable to acknowledge order!", "error");
          return;
        } else {
          this.order = resp.data
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    canUpdateOrderStatus: function () {
      let loggedInRole = this.$store.getters.user.userRolesById && this.$store.getters.user.userRolesById[0].role;
      let isAdmin = (loggedInRole === 'ROLE_ADMIN');
      let isAgent = (loggedInRole === 'ROLE_AGENT');
      let statusId = this.order.statusesByStatusId.id;
      let restaurantId = this.order.branchesByBranchId.restaurantsByRestaurantId.id;
      return (restaurantId === 37 || restaurantId === 40) || (((statusId !== 11) && (isAgent || isAdmin)) ||
          (statusId === 25 && isAdmin))
    },
    assignRider: function () {
      this.$refs.assignRiderModal.load(this.order, $("#order_view_model"))
    },
    editOrder: async function () {
      const param = new FormData()
      param.append('customer_id', this.order.dvmAddress.dvmCustomer.id)
      try {
        const {data} = await getBaykedCustomerAddresses(this.order.dvmAddress.dvmCustomer.id)
        this.bebambiCustomerAddresses = data
      } catch (e) {
        this.showErrorMessage(e)
      }

      this.isEditOrder = true
    },
    editButton(orderItemIndex, item, quantity) {

      if (!this.menuItemsLoaded && (!this.menuItems || this.menuItems.length === 0)) {
        getMenuItemByBranchId(this.order.branchesByBranchId.id).then(resp => {
          this.menuItems = resp.data.body;
          this.menuItemsLoaded = true;
        }).catch(e => {
          this.showErrorMessage(e);
        });
      }
      this.currentlyEditingIndex = orderItemIndex;
      this.editItemButton = true;
      this.item = item;
      this.quantity = quantity;
    },
    addItem() {
      // Find the maximum current ID in the existing items or default to 0
      const maxId = this.order.orderItemsById.reduce((max, item) => Math.max(max, item.id || 0), 0);

      const newId = maxId + 1;
      const newItem = {
        id: newId,  // Use the new unique ID
        quantity: 0,
        totalPrice: 0,
        discountedPrice: 0,
        instructions: '',
        NewItem: true,
        menuItemTypesByMenuItemTypeId: {
          menuItemsByMenuItemId: {
            id: null,
            name: '0'
          },
          price: 0,
          serving: ''
        }
      };

      this.order.orderItemsById.push(newItem);
      const newItemIndex = this.order.orderItemsById.length - 1;
      this.isEditOrder = true;
      this.isNewItem = true
      this.editButton(newItemIndex, "0", 0);
    },
    deleteOrderItem(menuItem, orderItemId) {
      // Check if there is only one item in the order or if the item is the first one (index 0)
      if (this.order.orderItemsById.length === 1) {
        Swal({
          title: 'Cannot Delete',
          text: "Only one item in order. You cannot delete the last item.",
          type: 'info',
          confirmButtonColor: '#1ab394',
          confirmButtonText: 'Okay'
        });
        return; // Stop further execution
      }

      Swal({
        title: 'Are you sure?',
        text: "Are you sure you want to delete this item!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#1ab394',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then(async (result) => {
        if (result.value) {
          const index = this.order.orderItemsById.findIndex(item => item.id === orderItemId);
          console.log("index", index);

          if (index !== -1) {
            const orderItem = this.order.orderItemsById[index];

            const isNewItem = orderItem.NewItem || false;

            // If it's a new item, remove it and also filter it out from the editOrderObject
            if (isNewItem) {
              console.log("is new item", isNewItem);
              this.order.orderItemsById.splice(index, 1);
              this.editOrderObject = this.editOrderObject.filter(item => item.orderItemId !== orderItemId);
            } else {
              // Otherwise, push the deletion action to editOrderObject
              this.editOrderObject.push({
                oldValue: orderItem.menuItemTypesByMenuItemTypeId.menuItemsByMenuItemId.name,
                newValue: "Deleted",
                field: UpdateOrderFields.DELETEITEM,
                itemId: menuItem,
                itemName: orderItem.menuItemTypesByMenuItemTypeId.menuItemsByMenuItemId.name,
                orderItemId: orderItemId,
                addressId: null,
              });

              // Remove the order item from the list
              this.order.orderItemsById.splice(index, 1);
            }
          }
        }
      });
    },

    handleItemChange(currentMenuItem, selectedMenuItemId, orderItemId) {

      // Remove previous activity ONLY for the same orderItemId and field (ITEM or ADDITEM)
      this.editOrderObject = this.editOrderObject.filter(item =>
          !(item.orderItemId === Number(orderItemId) && (item.field === UpdateOrderFields.ITEM || item.field === UpdateOrderFields.ADDITEM))
      );

      const selectedMenuItem = this.menuItems.find(item => item.id === Number(selectedMenuItemId));
      if (selectedMenuItem) {
        // Update the order item
        const orderItem = this.order.orderItemsById.find(item => item.id === orderItemId);
        if (orderItem) {
          orderItem.menuItemTypesByMenuItemTypeId.menuItemsByMenuItemId.name = selectedMenuItem.name;
          orderItem.menuItemTypesByMenuItemTypeId.price = selectedMenuItem.price;
          orderItem.menuItemTypesByMenuItemTypeId.serving = selectedMenuItem.serving;
          orderItem.totalPrice = orderItem.quantity * selectedMenuItem.price;
        }
        const isNewItem = orderItem.NewItem || false;

        const editField = isNewItem ? UpdateOrderFields.ADDITEM : UpdateOrderFields.ITEM;
        // Add the change to editOrderObject
        this.editOrderObject.push({
          oldValue: isNewItem ? "0" : currentMenuItem,
          newValue: selectedMenuItem.name,
          field: editField,
          itemId: selectedMenuItem.id,
          itemTypeId: selectedMenuItem.servingID,
          orderItemId: orderItemId,
          addressId: null,
        });
      }
    },
    filteredMenuItems(orderItem) {
      return this.menuItems.filter(e => e.id !== orderItem.menuItemTypesByMenuItemTypeId.menuItemsByMenuItemId.id);
    },

    handleQuantityChange(menuItemId, currentOrderItemId, updatedQuantity, oldQuantity) {
      // Remove previous activity ONLY for the same orderItemId and field (QUANTITY or ADDQUANTITY)
      this.editOrderObject = this.editOrderObject.filter(item =>
          !(item.orderItemId === Number(currentOrderItemId) && (item.field === UpdateOrderFields.QUANTITY || item.field === UpdateOrderFields.ADDQUANTITY))
      );

      // Update the order item quantity
      const orderItem = this.order.orderItemsById.find(item => item.id === currentOrderItemId);
      if (orderItem) {
        orderItem.quantity = updatedQuantity;
        orderItem.totalPrice = orderItem.quantity * orderItem.menuItemTypesByMenuItemTypeId.price;
      }
      const isNewItem = orderItem.NewItem || false;
      const editField = isNewItem ? UpdateOrderFields.ADDQUANTITY : UpdateOrderFields.QUANTITY;
      // Add the change to editOrderObject
      this.editOrderObject.push({
        oldValue: isNewItem ? 0 : oldQuantity,
        newValue: updatedQuantity,
        field: editField,
        itemId: menuItemId,
        orderItemId: currentOrderItemId,
        addressId: null,
      });

      return updatedQuantity;
    },

    close() {
      this.isEditOrder = false
      this.editItemButton = false
      this.isDeleted = false
      this.editOrderObject = [];
      this.bebambiCustomerAddresses = []
    },
    async updateOrder() {
      let hasError = false;

      for (const orderItem of this.order.orderItemsById) {
        if (orderItem.menuItemTypesByMenuItemTypeId.menuItemsByMenuItemId.name === "0") {
          swal("Error!", "Please select an item", "error");
          hasError = true;
          break;
        } else if (orderItem.quantity === "0" || orderItem.quantity <= 0) {
          swal("Error!", "Please select a quantity greater than 0", "error");
          hasError = true;
          break;
        }
      }
      if (hasError) {
        return;
      }

      const updateOrderDTO = {
        'orderId': this.order.id,
        'orderFields': this.editOrderObject
      };
      await updateOrder(updateOrderDTO);
      this.editOrderObject = [];
      this.quantity = 0;
      this.item = "0";
      this.isNewItem = false;
      this.close();
      $('#order_view_model').modal("hide");
    },

    addAddressToEditOrderArray(newAddress) {
      const currentAddress = this.order.dvmAddress.address
      // Check if an entry with field 'address' already exists
      const existingEntryIndex = this.editOrderObject.findIndex(entry => entry.field === 'address');
      if (newAddress.id === this.order.dvmAddress.id) {
        existingEntryIndex !== -1 && this.editOrderObject.splice(existingEntryIndex, 1);
        return
      }
      if (existingEntryIndex !== -1) {
        // Update the existing entry
        this.editOrderObject[existingEntryIndex].newValue = newAddress.address;
        this.editOrderObject[existingEntryIndex].addressId = newAddress.id;
      } else {
        // Push a new entry
        this.editOrderObject.push({
          'oldValue': currentAddress,
          'newValue': newAddress.address,
          'field': UpdateOrderFields.ADDRESS,
          'itemId': null,
          'orderItemId': null,
          'addressId': newAddress.id,
        });
      }
    },

    printOrder() {
      const WinPrint = window.open('', '', 'left=0,top=0,width=400,height=500px,toolbar=0,scrollbars=0,status=0');
      WinPrint.document.write(document.getElementById('print-order').innerHTML);
      WinPrint.document.close();
      WinPrint.focus();
      WinPrint.print();
      window.e = WinPrint;
      console.log('printing');
      setTimeout(() => {
        WinPrint.close();
      }, 500)
      console.log('closing')
    }
  }
}
</script>

<style scoped>
.modal {
  overflow: auto !important;
}

.branch {
  padding-left: 0;
  padding-right: 15px;
}

.half_legend {
  padding-right: 0;
  padding-left: 15px;
}

.full_legend {
  padding-right: 15px;
  padding-left: 15px
}

.custom_styling_on_row {
  margin-left: 0;
  margin-right: 0;
}

.order_feedback {
  padding-left: 0;
  padding-right: 0;
}

.center {
  display: flex;
  justify-content: center;
}

.menu_item_select_box {
  width: 100%;
  height: 3rem;
}

.vertical-divider {
  border-left: 1px solid #ccc;
  height: 18px;
  margin: 0 8px;
}
</style>